import React from 'react';
import { withTranslation } from 'react-i18next';
import EyeOffIcon from 'mdi-react/EyeOffIcon';

const HideArticle = ({t, onClick}) => (
    <span className="button-tag"><button
        className="draft_table-btn"
        title={t('posts.articles.tooltips.hide_article_on_blog')}
        type="button"
        onClick={onClick}><EyeOffIcon/></button></span>
)

export default withTranslation('dashboard')(HideArticle);
